import { registerPlugin, Capacitor } from '@capacitor/core';

const InstagramShare = registerPlugin('InstagramShare');

/**
 * Share a PNG image to Instagram Stories via native UIPasteboard API.
 * Only works on native iOS — throws on web/PWA.
 * @param {string} base64PNG - Full data URI or raw base64 PNG string
 */
export async function shareImageToInstagramStories(base64PNG) {
  if (!Capacitor.isNativePlatform()) {
    throw new Error('Instagram Stories sharing is only available on native iOS');
  }

  // Strip data URI prefix if present
  const raw = base64PNG.replace(/^data:image\/png;base64,/, '');
  console.log('[InstagramShare] Calling native, base64 length:', raw.length);
  const result = await InstagramShare.shareToStories({ base64: raw });
  console.log('[InstagramShare] Result:', JSON.stringify(result));

  if (result?.error) {
    throw new Error(result.error);
  }

  return result;
}
